import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLead } from './context/LeadProvider';
import LeadFilterStatus from './LeadsToolBar/LeadFilterStatus';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import { useNeedPay } from 'modules/admin';

interface LeadToolBarProps {
    setShowNewLead: (show: boolean) => void;
}

const LeadToolBar = ({ setShowNewLead }: LeadToolBarProps) => {
    const { t } = useTranslation(['Leads', 'common']);
    const { triggerListReset, triggerListRefresh } = useLead();
    const { needPay } = useNeedPay();

    return (
        <div className="mb-3" style={{ minWidth: '100px' }}>
            <div className="page-toolbar-actions">
                <Button
                    className="fs-14 ms-1"
                    size="sm"
                    variant="success"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        if (needPay()) return;
                        setShowNewLead(true);
                    }}
                >
                    <i className="bi bi-plus fs-14 p-0"></i>
                    <span className="ms-1">{t('toolAddLead')}</span>
                </Button>

                <ListToolBarActions onReset={triggerListReset} onRefresh={triggerListRefresh} />

                <LeadFilterStatus />
            </div>
        </div>
    );
};

export default LeadToolBar;
